import { render, staticRenderFns } from "./dadosPessoais.vue?vue&type=template&id=4874a160"
import script from "./dadosPessoais.vue?vue&type=script&lang=js"
export * from "./dadosPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports